var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = !_vm.loadding ? _vm.theme() || "" : null
  var m1 = !_vm.loadding ? _vm.theme() : null
  var m2 = !_vm.loadding ? _vm.topBarTop() : null
  var m3 = !_vm.loadding ? _vm.topBarHeight() : null
  var m4 = !_vm.loadding && !(m3 == 0) ? _vm.topBarHeight() : null
  var g0 =
    !_vm.loadding && !_vm.is_agent && _vm.isData
      ? _vm.setting.become == "50" && _vm.productList.length == 0
      : null
  var g1 =
    !_vm.loadding && !_vm.is_agent && _vm.isData
      ? _vm.setting.become == "50" && _vm.productList.length > 0
      : null
  var l0 =
    !_vm.loadding && !_vm.is_agent && _vm.isData && g1
      ? _vm.__map(_vm.productList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g2 = _vm.productList.length
          return {
            $orig: $orig,
            g2: g2,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        g0: g0,
        g1: g1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }